module.exports = {
  SET_PRODUCTS: 'SET_PRODUCTS',
  FETCHING_PRODUCTS: 'FETCHING_PRODUCTS',
  FETCHED_PRODUCTS: 'FETCHED_PRODUCTS',
  FETCH_PRODUCTS_ERROR: 'FETCH_PRODUCT_ERROR',
};
